import styled from '@emotion/styled';
import { Button } from '@mui/material';
import React from 'react'

function PrimaryButton(props) {

    const CustomButton = styled(Button)(({}) => ({
        color: "white",
        height: '100%',
        width: '100%',
        backgroundColor: 'var(--primary-color)',
        border: '1px solid white',
        borderRadius: '8px',
        boxShadow: 'none',
        fontFamily: "var(--primary-font-family)",
        fontSize: props.fontSize,
        fontWeight: "bold",
        '&:hover': {
          backgroundColor: "white",
          color: "var(--primary-color)",
          boxShadow: 'none',
          borderColor: 'var(--primary-color)',
        },
    }));

  return (
    <CustomButton onClick = {props.onClick}>{props.text}</CustomButton>
  )
}

export default PrimaryButton